import type { LucideIcon } from 'lucide-react';
import { Link } from 'react-router';

type Props = {
  icon: LucideIcon;
  value: string;
  href?: string;
  onClick?: VoidFunction;
};

export default function PartyDetail({ icon, value, href, onClick }: Props) {
  const Icon = icon;

  const blank = href?.startsWith('http');

  if (href) {
    return (
      <Link
        to={href ?? '#'}
        className="text-foreground flex w-full items-center gap-1.5 text-xs hover:underline"
        target={blank ? '_blank' : ''}
        rel="noopener noreferrer"
      >
        <Icon className="size-3" /> {value}
      </Link>
    );
  }

  return (
    <span
      onClick={onClick}
      className="text-foreground flex w-full cursor-pointer items-center gap-1.5 text-xs hover:underline"
    >
      <Icon className="size-3" /> {value}
    </span>
  );
}
